import PasswordLinkExpiredPage from './PasswordLinkExpiredPage';
import { PasswordLinkExpiredPageProps, PasswordLinkExpiredPageValueProps } from './types';

export type { PasswordLinkExpiredPageProps, PasswordLinkExpiredPageValueProps };
export default PasswordLinkExpiredPage;
